document.addEventListener("DOMContentLoaded", function () {
    initializeVariantHandlers();
});

function initializeVariantHandlers() {
    // Cache DOM queries for better performance
    const variantContainers = document.querySelectorAll('.product__variants');
    
    if (!variantContainers.length) return;

    variantContainers.forEach(function(variantContainer) {
        const product = variantContainer.closest('.product');
        if (!product) return;

        const form = product.querySelector('.add-to-cart-form');
        if (!form) return;

        const productId = form.getAttribute('data-product-id');
        const variantInput = form.querySelector('.variant-id-input');
        const addToCartBtn = form.querySelector('.add-to-cart-btn');
        const variantBtns = variantContainer.querySelectorAll('.variant-btn');

        if (!variantBtns.length) return;

        // Set first variant as active on load
        const firstVariant = variantBtns[0];
        if (firstVariant && !document.querySelector('.variant-btn.active')) {
            firstVariant.classList.add('active');
            updateProductState(productId, firstVariant, variantInput, addToCartBtn);
        }

        // Add click handlers to variant buttons
        variantBtns.forEach(function(btn) {
            btn.addEventListener('click', function() {
                handleVariantClick(productId, btn, variantBtns, variantInput, addToCartBtn);
            });
        });
    });
}

function handleVariantClick(productId, selectedBtn, allBtns, variantInput, addToCartBtn) {
    // Remove active class from all buttons
    allBtns.forEach(btn => btn.classList.remove('active'));
    
    // Add active class to selected button
    selectedBtn.classList.add('active');
    
    // Update product state
    updateProductState(productId, selectedBtn, variantInput, addToCartBtn);
}

function updateProductState(productId, variantBtn, variantInput, addToCartBtn) {
    const variantId = variantBtn.getAttribute('data-variant-id');
    const image = variantBtn.getAttribute('data-image');
    const price = variantBtn.getAttribute('data-price');
    const comparePrice = variantBtn.getAttribute('data-compare-price');
    const isAvailable = variantBtn.getAttribute('data-available') === 'true';

    // Update hidden form input
    if (variantInput && variantId) {
        variantInput.value = variantId;
    }

    // Update add to cart button state
    if (addToCartBtn) {
        addToCartBtn.disabled = !isAvailable;
        addToCartBtn.style.opacity = isAvailable ? '' : '0.5';
        addToCartBtn.style.cursor = isAvailable ? '' : 'not-allowed';
    }

    // Update product details (image and prices)
    updateProductDetails(productId, image, price, comparePrice);
}

function updateProductDetails(productId, imageUrl, price, comparePrice) {
    // Use more efficient selectors and cache results
    const productImage = document.getElementById(`product-image-${productId}`);
    const priceElement = document.getElementById(`price-${productId}`);
    const comparePriceElement = document.getElementById(`compare-${productId}`);

    if (productImage && imageUrl) {
        productImage.src = imageUrl;
    }
    
    if (priceElement && price) {
        priceElement.textContent = price;
    }
    
    if (comparePriceElement && comparePrice) {
        comparePriceElement.textContent = comparePrice;
    }
}

